import { transport } from 'config/transport';

export function callApiUpdateDangKyMonHoc(congDoanId, classId, studentId, body) {
    return transport.put(`/mamnon/${congDoanId}/thuhocsinh/${classId}/dangky/${studentId}/register`, body);
}
